exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-form__input__label{text-transform:uppercase;padding:0 0 .25em}", ""]);

// exports
